exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._26kxLhyc0y56iE4OC8jsYZ{width:100%;overflow:auto}html[dir] ._26kxLhyc0y56iE4OC8jsYZ{margin:17px;padding:0 3px}._3Sg193nzDoxNue4i5mwkpY{font-size:20px;font-weight:600;color:var(--neutralPrimary)}html[dir] ._3Sg193nzDoxNue4i5mwkpY{margin-bottom:24px;padding-bottom:19px;border-bottom:1px solid var(--neutralLight)}", ""]);
// Exports
exports.locals = {
	"container": "_26kxLhyc0y56iE4OC8jsYZ",
	"fileProvidersToAddContainer": "_3Sg193nzDoxNue4i5mwkpY"
};